import { HttpErrorResponse } from "@angular/common/http";
import { createAction } from "@ngrx/store";
import { UserSettings } from "app/global/user-settings.dto";
import { IRolesDto } from "./permission.reducer";
import { permissionsConfigKey } from "./permissions.config";

const scope = `[${permissionsConfigKey}]`;

export const refreshPermissionList = createAction(`${scope} Refresh permission list`, (userData: UserSettings)=>({userData}));

export const fetchRoles = createAction(`${scope} Fetch roles`);
export const fetchRolesSucceeded = createAction(`${scope} Fetch roles Succeeded`, (roles:IRolesDto[] )=> ({roles}));
export const fetchRolesFailed = createAction(`${scope} Fetch roles Failed`, (error: HttpErrorResponse)=> ({error}));